import * as types from './types';

export const updatePasswordBegin = () => ({
  type: types.UPDATE_PASSWORD_BEGIN
});

export const updatePasswordSuccess = () => ({
  type: types.UPDATE_PASSWORD_SUCCESS
});

export const updatePasswordFailure = (error: unknown) => ({
  type: types.UPDATE_PASSWORD_FAILURE,
  payload: error
});
